import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_ASPECT_RATIO = 4 / 5;

const style = () => {
  const {
    colorBgPrimaryMediumLight,
    colorBgPrimaryLight,
    space2,
    space4,
    colorBgBase,
    colorTextMedium,
    colorTextError,
  } = theme();

  return StyleSheet.create({
    brand: {
      color: colorTextMedium,
      marginTop: space2,
    },
    detailImage: {
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
      top: 0,
    },
    discount: {
      color: colorTextError,
    },
    discountWrapper: {
      display: "flex",
      flexDirection: "row",
    },
    footerInfoSmall: {
      paddingLeft: space4,
    },
    image: {
      flex: 1,
    },
    imageCta: {
      height: "100%",
      position: "relative",
      width: "100%",
    },
    imageCtaLarge: {
      backgroundColor: colorBgBase,
      borderColor: colorBgPrimaryLight,
      borderWidth: 1,
      marginBottom: space2,
    },
    imageWrapper: {
      aspectRatio: IMAGE_ASPECT_RATIO,
    },
    placeHolder: {
      backgroundColor: colorBgPrimaryMediumLight,
    },
    previousPrice: {
      color: colorTextMedium,
      marginLeft: space2,
      textDecorationLine: "line-through",
    },
    pricesWrapper: {
      display: "flex",
      flexDirection: "row",
    },
  });
};

export { style };
